import throttle from 'src/utils/throttle';

export default function header() {
  const header = document.querySelector(
    '[data-site-header]',
  ) as HTMLElement;
  const inner = header?.querySelector?.(
    '[data-site-header-inner]',
  ) as HTMLElement;
  const menuButton = header?.querySelector?.(
    '[data-site-menu-button]',
  ) as HTMLButtonElement;
  const menuNav = header?.querySelector?.(
    '[data-site-menu-nav]',
  ) as HTMLElement;

  if (!header || !inner || !menuButton || !menuNav) return;

  function getIsOpen() {
    return header.classList.contains('menu-open');
  }

  function getBodyEls() {
    return (
      Array.from(
        document.body.querySelectorAll(
          'body > *:not(script):not(style):not(link):not(meta):not(title)',
        ),
      ).filter((el) => el instanceof HTMLElement) as HTMLElement[]
    ).filter((el) => !el.dataset.siteHeader);
  }

  const handleResize = throttle(() => {
    if (window.innerWidth >= 1000) {
      handleClose();
    }
  });

  function handleEscape(e: KeyboardEvent) {
    if (e.key === 'Escape' && getIsOpen()) {
      e.preventDefault();
      handleClose();
    }
  }

  function handleOpen() {
    menuNav.inert = false;
    requestAnimationFrame(() => {
      header.scrollIntoView({ behavior: 'smooth' });
    });
    header.classList.add('menu-open');
    ['resize', 'orientationchange'].forEach((evt) =>
      window.addEventListener(evt, handleResize),
    );
    window.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    const bodyEls = getBodyEls();
    bodyEls.forEach((el) => {
      el.inert = true;
    });
  }

  function handleClose() {
    const bodyEls = getBodyEls();
    bodyEls.forEach((el) => {
      el.inert = false;
    });
    header.classList.remove('menu-open');
    ['resize', 'orientationchange'].forEach((evt) =>
      window.removeEventListener(evt, handleResize),
    );
    window.removeEventListener('keydown', handleEscape);
    document.body.style.overflow = '';
    menuNav.inert = true;
    menuButton.focus();
  }

  menuButton.addEventListener('click', () => {
    getIsOpen() ? handleClose() : handleOpen();
  });
  menuButton.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (!getIsOpen()) {
          handleOpen();
        }
        break;
      case 'ArrowUp':
        if (getIsOpen()) {
          e.preventDefault();
          handleClose();
        }
        break;
      default:
        break;
    }
  });
}
